export default "__VITE_ASSET__DVm776DI__"